// extracted by mini-css-extract-plugin
export var inputContainer = "br_dT";
export var inputForm = "br_dV";
export var inputFormError = "br_dW";
export var labelForm = "br_dX";
export var tipForm = "br_dY";
export var iconContainer = "br_dZ";
export var icon = "br_dK";